import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from './client';
import type { StaffMember, StaffRole, ActionResult } from './types';

export function useStaff() {
  return useQuery({
    queryKey: ['staff'],
    queryFn: () => apiFetch<StaffMember[]>('/staff'),
    staleTime: 30_000,
  });
}

export interface PatchStaffBody {
  role?: StaffRole;
  status?: 'active' | 'suspended';
}

export function usePatchStaff() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ userId, ...body }: { userId: string } & PatchStaffBody) =>
      apiFetch<StaffMember>(`/staff/${userId}`, {
        method: 'PATCH',
        body: JSON.stringify(body),
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['staff'] });
    },
  });
}

export function useDeleteStaff() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (userId: string) =>
      apiFetch<ActionResult>(`/staff/${userId}`, { method: 'DELETE' }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['staff'] });
    },
  });
}
